/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { classNames as o } from "@progress/kendo-react-common";
const n = (e) => {
  const { children: m, id: r, className: t, style: s } = e;
  return /* @__PURE__ */ a.createElement("div", { id: r, className: o("k-columnmenu-item-wrapper", t), style: s }, m);
};
export {
  n as GridColumnMenuItemGroup
};
